import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {ASMainGamePickOptions, WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration,
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {TombstoneGameMode} from "./gamemode/TombstoneGameMode";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {TombstoneSoundConfig} from "./TombstoneSoundConfig";
import {TombstoneGameAssets} from "./TombstoneGameAssets";
import {TombstoneGameModuleConfig} from "./TombstoneGameModuleConfig";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {TombstoneNoMercy} from "./TombstoneNoMercy";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";


export class TombstonePromoPanelConfig implements PromoPanelGameConfiguration {
    private wasFeatureBuy: boolean = false;

    constructor() {
    }

    public getActionSpinOptions(): ActionSpinOptions {
        return {
            gameName: "TombstoneNoMercy",
            hasActionSpin: true,
            mainGame: {
                header: () => "xBET",
                options: [
                    {name: "NORMAL", id: 0, image: "NORMAL.png"},
                    {name: "BOOSTED_BET", id: 1, image: "BOOSTED_BET.png"},
                    {name: "BOOSTED_BET_WILD", id: 2, image: "BOOSTED_BET_WILD.png"}
                ],
                type: ASMainGamePickOptions.BOOSTED_BET
            },
            graphics: {backgroundTextureName: TombstoneGameAssets.MAIN_GAME_BACKGROUND},
            getParsedData: (response: any, bet: number, prevResponse: any): ASWinData => {
                if (response.mode === TombstoneGameMode.NORMAL) {
                    this.wasFeatureBuy = response.wasFeatureBuy;
                }
                const parsedData: ASWinData = {
                    totalWin: response.accumulatedRoundWin,
                    totalSpinWinnings: this.getWin(response, bet, prevResponse),
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: this.isFreeSpinTriggered(response),
                    isBigWin: this.isBigWin(response),
                    winType: WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response),
                    isRoundComplete: this.isRoundComplete(response),
                    isBonusEnd: this.isBonusEnd(response),
                    isWinCapHit: response.brokeTheBank
                }
                return parsedData;
            }
        };
    }

    /*private isBigWin(response:any):boolean {
        const win = response.totalSpinWinnings;
        const playedBetValue = response.playedBetValue;
        let winRatio:number = Helper.ceilToDecimals((win / playedBetValue), 2);

        return winRatio >= 15;
    }*/

    public onActionSpinPlaySound(trigger: ActionSpinSound): void {
        if (trigger == ActionSpinSound.WIN) {
            SlotGame.sound.playEffect(TombstoneSoundConfig.instance.AS_WIN);
        } else if (trigger == ActionSpinSound.BIG_WIN) {
            SlotGame.sound.playEffect(TombstoneSoundConfig.instance.AS_WIN_BIG);
        }
    }

    private isBigWin(response: any): boolean {
        const win = response.totalSpinWinnings;

        if (response.wasFeatureBuy) {

            /*
                    I don't think I can fix this... As we need to do a calculation dividing win by (featureBetPrice), like this:
                    winRatio = MathHelper.ceilToDecimals((win / betPrice)
                    and if the win ratio is 1 or higher we show big win
             */
            const betPrice = TombstoneGameModuleConfig.initData.getBuyFeaturePrice();
            let winRatio: number = MathHelper.floorToDecimals((win / betPrice), 2);
            return winRatio >= 1;
        }

        let winRatio: number = MathHelper.ceilToDecimals((win / response.playedBetValue), 2);

        return winRatio >= 15;
    }

    private getWin(response: any, bet: number, prevData: any): number {
        return response.totalSpinWinnings;
    }

    private getFeatureName(response: any): string {
        if (response.mode == TombstoneGameMode.RESPIN || response.nextMode == TombstoneGameMode.RESPIN) {
            return "JUSTICE SPINS"
        }

        if (response.mode == TombstoneGameMode.FREESPIN || response.nextMode == TombstoneGameMode.FREESPIN) {
            return "GUNSLINGER SPINS"
        }
        if (response.mode == TombstoneGameMode.SUPER_FREESPIN || response.nextMode == TombstoneGameMode.SUPER_FREESPIN) {
            return "BOUNTY SPINS"
        }

        return "";
    }

    private isFreeSpinTriggered(response: any): boolean {
        const respin = response.bonusTriggeredThisSpin;
        const freespin = response.freespinTriggeredThisSpin;
        const sFs = response.mode == TombstoneGameMode.NORMAL && response.nextMode == TombstoneGameMode.SUPER_FREESPIN

        if ((respin || freespin || sFs) && response.nextMode !== TombstoneGameMode.NORMAL) {
            TombstoneNoMercy.api.events.trigger("removeCountUpForAS");
        }
        return (respin || freespin || sFs) && response.nextMode !== TombstoneGameMode.NORMAL;
    }

    private isRoundComplete(response: any): boolean {
        return ([TombstoneGameMode.NORMAL, TombstoneGameMode.RESPIN, TombstoneGameMode.FREESPIN, TombstoneGameMode.SUPER_FREESPIN].indexOf(response.nextMode) > -1);
    }

    private isBonusEnd(response: any): boolean {
        return response.nextMode === TombstoneGameMode.NORMAL && (response.mode.indexOf("NORMAL") === -1);
    }

}